import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow } from '@angular/material/table';
import { AppState } from '../../../../@store/app.reducers';
import { Store } from '@ngrx/store';
import { ComplementoWebService } from '../../../../services/complemento-web/complemento-web.service';
import { ModalConsultarTercerosComponent } from '../../@modals/modal-consultar-terceros/modal-consultar-terceros.component';
import { MatDialog } from '@angular/material/dialog';
import { selectDetalleSiniestroSiniestros, selectListaCatalogosSiniestros, selectObjetoDetalleSiniestroSiniestros, selectSiniestroSiniestros } from '../../@store/complemento-web/complemento-web.selectors';
import { MatPaginator } from '@angular/material/paginator';
import { AseguradoTerceroLesionado, ConsultaSiniestroOutput, TerceroComplemento } from 'src/app/models/complementos-web/complementos-web.model';
import { ProcesosComunesComplementoService } from 'src/app/services/complemento-web/procesos-comunes-complemento.service';
import { combineLatest, skipWhile, Subscription } from 'rxjs';
import { ActivarLoadingAction, DesactivarLoadingAction, MostrarMensajeErrorAction } from 'src/app/@store/actions';
import { importeMayorACeroValidator } from '../../@validators/validators-complemento';
import { PaginaDatosTablaComponent } from "../pagina-datos-tabla/pagina-datos-tabla.component";
import { NgClass, SlicePipe } from '@angular/common';
import { MatButton, MatMiniFabButton } from '@angular/material/button';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatSelect, MatOption } from '@angular/material/select';
import { UpperCaseTextDirective } from '../../../../@shared/directives/upper-case.directive';
import { OnlyNumber } from '../../../../@shared/directives/only-number.directive';
import { FormatoNumeroMonedaCoplementoWebDirective } from '../../@directives/formato-numero-moneda.directiva';

@Component({
    selector: 'app-crear-actualizar-ocupante-tercero',
    templateUrl: './crear-actualizar-ocupante-tercero.component.html',
    styleUrls: ['./crear-actualizar-ocupante-tercero.component.scss'],
    imports: [MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow, NgClass, PaginaDatosTablaComponent, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatError, MatMiniFabButton, MatIcon, MatSelect, MatOption, UpperCaseTextDirective, OnlyNumber, FormatoNumeroMonedaCoplementoWebDirective, SlicePipe]
})
export class CrearActualizarOcupanteTerceroComponent implements OnInit, AfterViewInit, OnChanges {

  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Input() public datosTercero: MatTableDataSource<any> = new MatTableDataSource([]);

  @Output() eventosOcupantes = new EventEmitter();

  public displayColumns = ['Nombre', 'Estatus', 'Acciones'];

  public detalleSiniestro = null;
  public siniestro: string;
  public detalleSiniestroCompleto: ConsultaSiniestroOutput;
  public lesionadoSeleccionado: AseguradoTerceroLesionado;
  public listaObservables = new Subscription();

  public tamanoResultados: number = 0;
  public formAsegurado: FormGroup;
  public terceroSelecciona = null;
  public habilitaAsegurado = false;
  private formSubscripciones = new Subscription();
  public paginatorInfo = { pageStart: 0, pageEnd: 0 };

  public catEstatus = [];

  constructor(
    private store: Store<AppState>,
    private dialog: MatDialog,
    private complementoWebService: ComplementoWebService,
    private procesosComunesService: ProcesosComunesComplementoService,
  ) {
    this.crearFormulario();
    this.obtenerReduxState();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.['datosTercero']?.currentValue) {
    }
  }

  ngOnDestroy(): void {
    this.listaObservables.unsubscribe();
  }

  ngOnInit(): void {
    this.obtenerCatalogos();
    this.cambiosFormulario();
  }

  ngAfterViewInit(): void {
    this.datosTercero.paginator = this.paginator;
  }

  obtenerReduxState() {
    const subsComplemento = combineLatest([
      this.store.select(selectSiniestroSiniestros),
      this.store.select(selectObjetoDetalleSiniestroSiniestros).pipe(skipWhile(datos => datos == null)),
      this.store.select(selectDetalleSiniestroSiniestros),
    ]).subscribe(([siniestro, detalleCompleto, detalleBase]) => {
      this.siniestro = siniestro;
      this.detalleSiniestroCompleto = detalleCompleto;
      this.detalleSiniestro = { ...detalleBase };
    });
    this.listaObservables.add(subsComplemento);
  }

  obtenerCatalogos() {
    this.store.select(selectListaCatalogosSiniestros).subscribe({
      next: (value) => {
        this.catEstatus = value.consultaEstatusLesionado;
      },
    });
  }

  crearFormulario() {
    this.formAsegurado = new FormGroup({
      tipoTercero: new FormControl({ value: null, disabled: true }, [Validators.required]),
      idTercero: new FormControl(null),
      estatus: new FormControl(null, [Validators.required]),
      nombre: new FormControl(null, [Validators.required]),
      apellidoPaterno: new FormControl(null, [Validators.required]),
      apellidoMaterno: new FormControl(null, [Validators.required]),
      edad: new FormControl(null),
      importe: new FormControl(null, [Validators.required, importeMayorACeroValidator()]),
    })
  }

  cambiosFormulario() {
    this.formSubscripciones.unsubscribe();
    this.formSubscripciones = new Subscription();

    const subsTipoTercero = this.formAsegurado.get('tipoTercero').valueChanges.subscribe({
      next: (value) => {
        if (value) {
          this.formAsegurado.get('nombre').disable({ onlySelf: true });
          this.formAsegurado.get('apellidoPaterno').disable({ onlySelf: true });
          this.formAsegurado.get('apellidoMaterno').disable({ onlySelf: true });
          this.formAsegurado.get('edad').disable({ onlySelf: true });
        }
      },
    });
    const subsTipoOcupante = this.formAsegurado.get('estatus').valueChanges.subscribe({
      next: (value) => {
        if (value == 3) this.formAsegurado.get('importe').setValue(null);
        if ([1, 3, 4].includes(value)) {
          this.formAsegurado.get('nombre').setValidators(Validators.required);
          this.formAsegurado.get('nombre').updateValueAndValidity();
          this.formAsegurado.get('apellidoPaterno').setValidators(Validators.required);
          this.formAsegurado.get('apellidoPaterno').updateValueAndValidity();
          this.formAsegurado.get('apellidoMaterno').setValidators(Validators.required);
          this.formAsegurado.get('apellidoMaterno').updateValueAndValidity();
        } else {
          this.formAsegurado.get('nombre').setValidators(null);
          this.formAsegurado.get('nombre').updateValueAndValidity();
          this.formAsegurado.get('apellidoPaterno').setValidators(null);
          this.formAsegurado.get('apellidoPaterno').updateValueAndValidity();
          this.formAsegurado.get('apellidoMaterno').setValidators(null);
          this.formAsegurado.get('apellidoMaterno').updateValueAndValidity();
        }

        if ([1, 2, 4].includes(value)) {
          this.formAsegurado.get('importe').setValidators([Validators.required, importeMayorACeroValidator()]);
          this.formAsegurado.get('importe').updateValueAndValidity();
        } else {
          this.formAsegurado.get('importe').setValidators(null);
          this.formAsegurado.get('importe').updateValueAndValidity();
        }
      },
    });
    this.formSubscripciones.add(subsTipoOcupante);
    this.formSubscripciones.add(subsTipoTercero);
  }


  abrirSeccionTercero(tercero?: AseguradoTerceroLesionado) {
    this.habilitaAsegurado = true;

    if (tercero) {
      this.terceroSelecciona = tercero;
      this.consultarLesionado(this.siniestro, tercero);
    }
  }

  guardarTercero(tercero?: AseguradoTerceroLesionado) {
    // Validación de campos requeridos
    if (!this.formAsegurado.valid) {
      this.procesosComunesService.alertaGeneralComplemento('Aviso', '', 'warning', false, true, "Debes capturar los campos requeridos");
      return this.formAsegurado.markAllAsTouched();
    }
    if (this.validarRegistro(2, this.detalleSiniestroCompleto.Siniestro[0].respons_sini, this.formAsegurado.get('estatus').value, this.lesionadoSeleccionado?.estatus_tercero ?? "0", this.formAsegurado.get('importe').value)) {
      const siniestroFormateado = this.procesosComunesService.devolverSiniestro(this.siniestro);
      const nombreLesionado = `${this.formAsegurado.get('nombre').value}|${this.formAsegurado.get('apellidoPaterno').value}|${this.formAsegurado.get('apellidoMaterno').value}`;
      const request = {
        sucursal: this.detalleSiniestroCompleto.Siniestro[0].sucursalk1,
        linea: this.detalleSiniestroCompleto.Siniestro[0].cve_linea,
        producto: this.detalleSiniestroCompleto.Siniestro[0].cve_prod,
        poliza: this.detalleSiniestroCompleto.Siniestro[0].polizak1,
        endoso: this.detalleSiniestroCompleto.Siniestro[0].endosok1,
        a_emision: this.detalleSiniestroCompleto.Siniestro[0].a_emisionk,
        no_reexpedicion: this.detalleSiniestroCompleto.Siniestro[0].no_reexpedicionk,
        cve_linea_ind: this.detalleSiniestroCompleto.Siniestro[0].cve_linea_indk,
        cve_secc_gpo: this.detalleSiniestroCompleto.Siniestro[0].cve_secc_gpok,
        inciso: this.detalleSiniestroCompleto.Siniestro[0].num_incisok,
        num_depend: this.detalleSiniestroCompleto.Siniestro[0].num_dependk,
        fechaSiniestro: this.detalleSiniestroCompleto.Siniestro[0].fecsini,
        moneda: siniestroFormateado.moneda,
        ramo: siniestroFormateado.ramo,
        sramo: siniestroFormateado.sramo,
        oficina: siniestroFormateado.oficina,
        consecutivo: siniestroFormateado.consecutivo,
        anio: siniestroFormateado.anio,
        tipoCliente: 2,
        id_lesionado: tercero?.id_lesionado ?? undefined,
        nombre: nombreLesionado,
        edad: this.formAsegurado.get('edad').value,
        id_tercero: tercero?.id_tercero ?? this.formAsegurado.get('idTercero').value ?? 0,
        tipo: this.formAsegurado.get('estatus').value,
        importe: this.formAsegurado.get('importe').value,
        numeroLiga: tercero?.hospital_lesionado ?? 0,
        proveedor: "",
      }
      console.log(request)
      this.store.dispatch(ActivarLoadingAction());
      this.complementoWebService.guardaActualizaLesionado(request).subscribe({
        next: (value) => {
          this.store.dispatch(DesactivarLoadingAction());
          if (value.Resultado.IdLesionado && value.Exito) {
            this.procesosComunesService.alertaGeneralComplemento('Guardado', `Se guardó/actualizó la información del lesionado correctamente.`, 'success', false, true);
            this.regresaConsulta();
            this.eventosOcupantes.emit();
          } else {
            this.procesosComunesService.alertaGeneralComplemento('Aviso', `No se pudo guardar o actualizar la información.`, 'info', false, true);
          }
        },
        error: (err) => {
          this.store.dispatch(DesactivarLoadingAction());
          this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos procesar el guardado del lesionado' }));
        },
      })
    } else {
      this.formAsegurado.markAllAsTouched();
    }
  }

  eliminarTercero(tercero: AseguradoTerceroLesionado) {
    const siniestroFormateado = this.procesosComunesService.devolverSiniestro(this.siniestro);
    const request = {
      sucursal: this.detalleSiniestroCompleto.Siniestro[0].sucursalk1,
      linea: this.detalleSiniestroCompleto.Siniestro[0].cve_linea,
      producto: this.detalleSiniestroCompleto.Siniestro[0].cve_prod,
      poliza: this.detalleSiniestroCompleto.Siniestro[0].polizak1,
      endoso: this.detalleSiniestroCompleto.Siniestro[0].endosok1,
      a_emision: this.detalleSiniestroCompleto.Siniestro[0].a_emisionk,
      no_reexpedicion: this.detalleSiniestroCompleto.Siniestro[0].no_reexpedicionk,
      cve_linea_ind: this.detalleSiniestroCompleto.Siniestro[0].cve_linea_indk,
      cve_secc_gpo: this.detalleSiniestroCompleto.Siniestro[0].cve_secc_gpok,
      inciso: this.detalleSiniestroCompleto.Siniestro[0].num_incisok,
      num_depend: this.detalleSiniestroCompleto.Siniestro[0].num_dependk,
      fechaSiniestro: this.detalleSiniestroCompleto.Siniestro[0].fecsini,
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      tipoCliente: 2,
      id_lesionado: tercero.id_lesionado ?? 0,
      id_tercero: tercero?.id_tercero ?? 0,
      tipo: tercero?.tipo ?? 0,
    }

    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.eliminaLesionado(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        if (value.Exito) {
          this.procesosComunesService.alertaGeneralComplemento('Guardado', `La información se eliminó correctamente.`, 'success', false, true);
          this.regresaConsulta();
          this.eventosOcupantes.emit();
        } else {
          this.procesosComunesService.alertaGeneralComplemento('Aviso', `No se pudo eliminar la información.`, 'info', false, true);
        }
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos procesar la eliminación del lesionado' }));
      },
    })
  }

  regresaConsulta() {
    this.habilitaAsegurado = false;
    this.catEstatus = [];
    this.terceroSelecciona = null;
    this.lesionadoSeleccionado = null;
    this.crearFormulario();
    this.cambiosFormulario();
  }

  setFormulario() {
    const nombreLesionado = this.procesaNombreLesionado();
    const descripcionTer = this.lesionadoSeleccionado.desc_tipo_tercero;
    this.formAsegurado.patchValue({
      tipoTercero: descripcionTer,
      idTercero: this.lesionadoSeleccionado.id_tercero,
      estatus: this.terceroSelecciona.tipo,
      nombre: nombreLesionado?.nombre || null,
      apellidoPaterno: nombreLesionado?.apellidoPaterno || null,
      apellidoMaterno: nombreLesionado?.apellidoMaterno || null,
      edad: this.terceroSelecciona.edad,
      importe: this.terceroSelecciona.importe != "$.00" ? parseFloat(this.terceroSelecciona.importe.replace(/[$,]/g, '')) : 0,
    })

    console.log(this.formAsegurado.getRawValue());
  }

  procesaNombreLesionado() {
    if (!this.terceroSelecciona.nombre_lesionado) return {
      nombre: null,
      apellidoPaterno: null,
      apellidoMaterno: null,
    }
    const splitNombre = this.terceroSelecciona.nombre_lesionado.split("|");
    return {
      nombre: splitNombre[0],
      apellidoPaterno: splitNombre[1],
      apellidoMaterno: splitNombre[2],
    }
  }

  abrirModalTiposTerceros() {
    const dialog = this.dialog.open(ModalConsultarTercerosComponent, {
      width: '680px',
      height: 'auto',
      closeOnNavigation: true,
      hasBackdrop: true,
      disableClose: true,
      data: { modulo: "Lesionados", },
    }).afterClosed().subscribe((data: TerceroComplemento) => {
      if (data) {
        this.procesaSeleccionTercero(data);
      }
    });
  }
  procesaSeleccionTercero(data: TerceroComplemento) {
    console.log(data)
    const descripcionTer = data.tipo_tercero == 1 ? data.placas : data.desc_tipo_tercero;
    this.formAsegurado.patchValue({
      tipoTercero: descripcionTer,
      idTercero: data.id_tercero,
    });

    if ((data.tipo_tercero == 4 || data.tipo_tercero == 5)) {
      this.formAsegurado.patchValue({
        nombre: data.nombre,
        apellidoPaterno: data.ap_paterno,
        apellidoMaterno: data.ap_materno,
        edad: data.edad
      });
      this.formAsegurado.get('nombre').disable({ onlySelf: true });
      this.formAsegurado.get('apellidoPaterno').disable({ onlySelf: true });
      this.formAsegurado.get('apellidoMaterno').disable({ onlySelf: true });
      this.formAsegurado.get('edad').disable({ onlySelf: true });

    }

    if (data.tipo_tercero == 1) {
      this.formAsegurado.patchValue({
        nombre: null,
        apellidoPaterno: null,
        apellidoMaterno: null,
        edad: null
      });

      this.formAsegurado.get('nombre').enable({ onlySelf: true });
      this.formAsegurado.get('apellidoPaterno').enable({ onlySelf: true });
      this.formAsegurado.get('apellidoMaterno').enable({ onlySelf: true });
      this.formAsegurado.get('edad').enable({ onlySelf: true });
    }
  }

  consultarLesionado(siniestro: string, lesionado: AseguradoTerceroLesionado) {
    const siniestroFormateado = this.procesosComunesService.devolverSiniestro(siniestro);
    const request = {
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      tipoCliente: 2,
      id_lesionado: lesionado.id_lesionado
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaLesionados(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        if (value.Resultado.Lesionado.length) {
          this.lesionadoSeleccionado = value.Resultado.Lesionado[0];
          this.setFormulario();
          const esHospital = this.lesionadoSeleccionado.hospital_lesionado == 0;
          const disable = this.lesionadoSeleccionado.hospital_lesionado > 0;

          if (disable) {
            this.formAsegurado.get('importe')?.disable({ onlySelf: true });
            if (this.lesionadoSeleccionado.tipo_prestador == 21) {
              this.formAsegurado.get('edad')?.disable({ onlySelf: true });
            }
            if ([4, 5].includes(this.lesionadoSeleccionado.tipo_tercero)) {
              this.formAsegurado.get('nombre').disable({ onlySelf: true });
              this.formAsegurado.get('apellidoPaterno').disable({ onlySelf: true });
              this.formAsegurado.get('apellidoMaterno').disable({ onlySelf: true });
              this.formAsegurado.get('edad').disable({ onlySelf: true });
            }
          } else {
            this.formAsegurado.get('importe')?.enable({ onlySelf: true });
            this.formAsegurado.get('estatus')?.enable({ emitEvent: false });
          }

          if (esHospital == false) {
            this.formAsegurado.get('estatus')?.disable({ emitEvent: false });
          }

          if (this.lesionadoSeleccionado.tipo_tercero == 1) {
            this.formAsegurado.get('nombre').enable({ onlySelf: true });
            this.formAsegurado.get('apellidoPaterno').enable({ onlySelf: true });
            this.formAsegurado.get('apellidoMaterno').enable({ onlySelf: true });
            this.formAsegurado.get('edad').enable({ onlySelf: true });
          }
        } else {
          // this.procesosComunesService.alertaGeneralComplemento('Aviso', `No se encontró ningun servicio`, 'info', false, true);
        }
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener el detalle del lesinado.' }));
      },
    })
  }

  validarRegistro(tipoCliente: number, responsable: number, estatusOcupante: number, estatusTercero: string, importe: string): boolean {
    // Validación 1: Tercero sin estatus válido
    if (tipoCliente == 2 && responsable == 2 && estatusOcupante != 3) {
      if (!['5', '6'].includes(estatusTercero)) {
        this.procesosComunesService.alertaGeneralComplemento(
          'Validación del tercero',
          'No se puede Guardar/Actualizar el registro debido a que el responsable es el tercero y el tercero seleccionado no tiene estatus MP o JUEZ CÍVICO.',
          'warning',
          false,
          true
        );
        this.formAsegurado.markAllAsTouched();
        return false;
      }
    }

    // Validación 2: Importe no válido
    if (importe?.length) {
      const importeNumerico = parseFloat(importe.replace(/,/g, ''));
      if (importeNumerico <= 0) {
        this.procesosComunesService.alertaGeneralComplemento(
          'Validación del importe',
          'No se puede guardar/actualizar debido a que el importe tiene que ser mayor a cero.',
          'warning',
          false,
          true
        );
        this.formAsegurado.markAllAsTouched();
        return false;
      }
    }

    // Validación 3: Tipo tercero no válido
    if (this.formAsegurado.getRawValue().tipoTercero == null && tipoCliente == 2) {
      this.procesosComunesService.alertaGeneralComplemento(
        'Validación del tipo tercero',
        'No se puede guardar/actualizar debido a que el tipo tercero no ha sido seleccionado.',
        'warning',
        false,
        true
      );
      this.formAsegurado.markAllAsTouched();
      return false;
    }

    return true; // Todo correcto
  }

  validaEliminacion(asegurado: AseguradoTerceroLesionado) {
    this.procesosComunesService.alertaGeneralComplemento(
      'Aviso!',
      '¿Está seguro que desea eliminar el registro?.',
      'question',
      true,
      true
    ).then(result => {
      if (result.isConfirmed) {
        this.eliminarTercero(asegurado);
      }
    });
  }

}
